import { matchesAnalyticsBatch, matchesMachine } from "../../components/analytics/analyticsFilters";

const numberOrNull = (value) => value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value)) ? Number(value) : null;

export const getMachineAnalytics = (filters = {}, machines = [], batches = [], plantId = "") =>
  machines.filter((machine) => matchesMachine(machine, filters, plantId)).map((machine) => {
    const related = batches.filter((batch) => matchesAnalyticsBatch(batch, { ...filters, machine: machine.machine_id }, plantId));
    const rawBatches = related.map((batch) => batch.raw || batch);
    const totalProduction = rawBatches.every((batch) => numberOrNull(batch.total_cycles) !== null)
      ? rawBatches.reduce((total, batch) => total + Number(batch.total_cycles), 0) : null;
    const goodParts = rawBatches.every((batch) => numberOrNull(batch.ok_parts) !== null)
      ? rawBatches.reduce((total, batch) => total + Number(batch.ok_parts), 0) : null;
    return {
      id: machine.machine_id,
      name: machine.machine_name || machine.machine_id,
      lineId: machine.line_id,
      machineType: machine.relation_type || machine.machine_type || "",
      totalProduction,
      // Production targets and availability are not part of the machine contract.
      productivity: null,
      utilization: null,
      quality: totalProduction > 0 && goodParts !== null ? Number((goodParts / totalProduction * 100).toFixed(1)) : null,
    };
  });

export const metricTone = (value) => {
  if (value == null) return "text-slate-400";
  if (value >= 90) return "text-emerald-600";
  if (value >= 80) return "text-amber-600";
  return "text-rose-600";
};
